/* eslint-disable no-shadow */
/* eslint-disable no-plusplus */
/* eslint-disable react/prop-types */
// import EmailIcon from "@mui/icons-material/Email";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import PhoneIcon from "@mui/icons-material/Phone";
// import ToggleOffIcon from "@mui/icons-material/ToggleOff";
// import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import { TableCell, TableRow } from "@mui/material";
import React, { useEffect, useState } from "react";
// import moment from "moment";
import Table from "../../../../components/common/new/Table/Table";
import tableStyle from "../../../../theme/styles/table";
// import { PERMISSIONS } from "../../../../contants";
import styles from "./AttendanceReportsTable.styles";
import Typography from "../../../../components/common/new/Typography/Typography";
// import NewTable from "../../../member/components/Newtable/NewTable";

const tabelCellWidth = {
  tiny: {
    maxWidth: "3.5rem",
    textAlign: "center",
  },
  small: {
    maxWidth: "6rem",
    textAlign: "center",
  },
  medium: {
    maxWidth: "10rem",
    textAlign: "center",
  },
  large: {
    maxWidth: "20rem",
    textAlign: "center",
  },
};
const FRIEND_SEAECH_TABLE_COL = [
  {
    displayName: "S.No",
    key: "s.no",
  },
  {
    displayName: "Member ID",
    key: "id",
  },
  {
    displayName: "Name",
    key: "fullName",
  },
  {
    displayName: "Division",
    key: "division",
  },
  {
    displayName: "Below Orgnization Structure",
    key: "block",
  },
  // {
  //   displayName: "Total",
  //   key: "total",
  // },
];

const getRows = ({
  searchData,
  currentPage,
  pageSize,
  // initialAdvanceFormValue,
  //   onSelectMember,
  //   onSelectMemberForTransfer,
  //   hasPermission,
  // showStatusColumn,
  // onMemberStatusToggle,
  //   startDate,
  //   EndDate,
  appliedFilters,
}) =>
  searchData.map((attendanceInfo, index) => {
    const serialNumber = index + 1 + currentPage * pageSize;
    let total = 0;
    const monthCells = attendanceInfo.monthsData.map((monthData) => {
      // if (!FRIEND_SEAECH_TABLE_COL.some((col) => col.key === "total")) {
      //   FRIEND_SEAECH_TABLE_COL.push({
      //     displayName: "Total",
      //     key: "total",
      //   });
      // }
      if (monthData.present) {
        total += 1;
      }
      return (
        <TableCell style={tabelCellWidth.medium}>
          <Typography style={styles.typoghrphyStyle}>
            {monthData.present ? 1 : 0}
          </Typography>
        </TableCell>
      );
    });
    const totalCell = (
      <TableCell style={tabelCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>{total}</Typography>
      </TableCell>
    );

    const getLocationString = (attendanceInfo, appliedFilters) => {
      const locationData = [];

      if (appliedFilters.some((filter) => filter.key === "areaId")) {
        locationData.push(attendanceInfo?.clusterName);
        locationData.push(attendanceInfo?.zoneName);
        locationData.push(attendanceInfo?.regionName);
        locationData.push(attendanceInfo?.chapterName);
        locationData.push(attendanceInfo?.districtName);
        locationData.push(attendanceInfo?.blockName);
      }
      if (appliedFilters.some((filter) => filter.key === "clusterId")) {
        locationData.shift();
      }
      if (appliedFilters.some((filter) => filter.key === "zoneId")) {
        locationData.shift();
      }
      if (appliedFilters.some((filter) => filter.key === "regionId")) {
        locationData.shift();
      }
      if (appliedFilters.some((filter) => filter.key === "chapterId")) {
        locationData.shift();
      }
      if (appliedFilters.some((filter) => filter.key === "districtId")) {
        locationData.shift();
      }

      return locationData.filter(Boolean).join(" / ");
    };

    const locationString = getLocationString(attendanceInfo, appliedFilters);

    return (
      <TableRow style={tableStyle.tableRow}>
        <TableCell style={tabelCellWidth.medium}>
          {" "}
          <Typography style={styles.typoghrphyStyle}>
            {serialNumber}
          </Typography>{" "}
        </TableCell>
        <TableCell style={tabelCellWidth.medium}>
          {" "}
          <Typography style={styles.typoghrphyStyle}>
            {attendanceInfo?.memberId || "NA"}
          </Typography>{" "}
        </TableCell>
        <TableCell style={tabelCellWidth.large}>
          <Typography style={styles.typoghrphyStyle}>
            {attendanceInfo?.fullName || "NA"}
          </Typography>{" "}
        </TableCell>
        <TableCell style={tabelCellWidth.small}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {attendanceInfo?.divisionName || "NA"}
            </Typography>
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography
              style={
                appliedFilters.some((filter) => filter.key === "districtId")
                  ? {
                      ...styles.typoghrphyStyle,
                      display: "flex",
                      justifyContent: "center",
                    }
                  : styles.typoghrphyStyle
              }
            >
              {/* {`${attendanceInfo?.areaName || "-"} / ${
                attendanceInfo?.zoneName || "-"
              } / ${attendanceInfo?.regionName || "-"} / ${
                attendanceInfo?.chapterName || "-"
              } / ${attendanceInfo?.districtName || "-"}`} */}

              {locationString || "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        {monthCells}
        {totalCell}
      </TableRow>
    );
  });

function ReportTable({
  searchData,
  currentPage,
  pageSize,
  onSelectMemberForTransfer,
  onMemberStatusToggle,
  onSelectMember,
  hasPermission,
  showStatusColumn,
  initialAdvanceFormValue,
  appliedFilters,
}) {
  const [tableColumns, setTableColumns] = useState([]);
  useEffect(() => {
    // Update table columns when the searchData changes
    const updatedColumns = [...FRIEND_SEAECH_TABLE_COL];

    if (searchData.length > 0) {
      const { monthsData } = searchData[0];
      if (monthsData && monthsData.length > 0) {
        monthsData.forEach((monthInfo) => {
          const { monthName } = monthInfo;
          const monthKey = monthName.toLowerCase();

          if (!updatedColumns.some((col) => col.key === monthKey)) {
            updatedColumns.push({
              displayName: monthName,
              key: monthKey,
            });
          }
        });
      }
    }
    updatedColumns.push({
      displayName: "Total",
      key: "total",
    });

    setTableColumns(updatedColumns);
  }, [searchData]);
  // const { monthsData } = searchData[0];
  // if (monthsData && monthsData.length > 0) {
  //   monthsData.forEach((monthInfo) => {
  //     const { monthName } = monthInfo;
  //     const monthKey = monthName.toLowerCase();

  //     if (!FRIEND_SEAECH_TABLE_COL.some((col) => col.key === monthKey)) {
  //       FRIEND_SEAECH_TABLE_COL.push({
  //         displayName: monthName,
  //         key: monthKey,
  //       });
  //     }
  //   });
  // }
  const columns = tableColumns;
  // const columns = showStatusColumn
  //   ? FRIEND_SEAECH_TABLE_COL
  //   : FRIEND_SEAECH_TABLE_COL.filter(
  //       (c) => c.key !== "mobile" && c.key !== "address"
  //     );

  return (
    <div style={styles.container}>
      <Table
        scrollable
        columns={columns}
        rows={getRows({
          searchData,
          currentPage,
          pageSize,
          onSelectMemberForTransfer,
          onSelectMember,
          hasPermission,
          onMemberStatusToggle,
          showStatusColumn,
          initialAdvanceFormValue,
          appliedFilters,
        })}
        tableBodyTheme="#F6F6F6"
        tableHeadCellStyle={{
          ...styles.tableHeadCells,
          textAlign: "center",
        }}
      />
    </div>
  );
}

export default ReportTable;
